document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-php-size-calculator]').forEach((root) => {
    const i18n = JSON.parse(root.querySelector('[data-php-i18n]')?.textContent || '{}');
    const sid = root.dataset.sectionId;
    const el = (name) => root.querySelector(`[data-field="${name}"]`);

    let currentShape = 'rect';

    const products = [
      { name: 'Manatee M18', btu: 18000, gal: 5000, url: 'https://www.turbro.com/products/manatee-m20-swimming-pool-heat-pump' },
      { name: 'Beluga B33V', btu: 32412, gal: 10000, url: 'https://www.turbro.com/products/beluga-inverter-swimming-pool-heat-pump?variant=44026028589098' },
      { name: 'Beluga B50V', btu: 52200, gal: 16000, url: 'https://www.turbro.com/products/beluga-inverter-swimming-pool-heat-pump-50v-75v?variant=41982964301866' },
      { name: 'Beluga B58V', btu: 58004, gal: 18000, url: 'https://www.turbro.com/products/beluga-inverter-swimming-pool-heat-pump?variant=44026028654634' },
      { name: 'Beluga B75V', btu: 72400, gal: 21100, url: 'https://www.turbro.com/products/beluga-inverter-swimming-pool-heat-pump-50v-75v?variant=41982964334634' },
      { name: 'Beluga B100V', btu: 95563, gal: 26000, url: 'https://www.turbro.com/products/beluga-inverter-swimming-pool-heat-pump' },
      { name: 'Beluga B120V', btu: 116000, gal: 30000, url: 'https://www.turbro.com/products/beluga-inverter-top-discharge-swimming-pool-heat-pump' },
      { name: 'Beluga B160V', btu: 143450, gal: 40100, url: 'https://www.turbro.com/products/beluga-inverter-top-discharge-swimming-pool-heat-pump?variant=44026011222058' }
    ];

    const filterPumps = [
      { name: 'FlowMind FM530 (Cartridge Filter)', gal: 4000, url: 'https://www.turbro.com/products/flowmind-cartridge-filter-pump' },
      { name: 'FlowMind FM1K (Cartridge Filter)', gal: 6000, url: 'https://www.turbro.com/products/flowmind-cartridge-filter-pump?variant=44299074863146' },
      { name: 'FlowCore FC12 (Sand Filter)', gal: 10000, url: 'https://www.turbro.com/products/flowcore-fc12-sand-filter-pump' },
      { name: 'FlowCore FC16 (Sand Filter)', gal: 16000, url: 'https://www.turbro.com/products/flowcore-fc16-sand-filter-pump' }
    ];

    const waterPumps = [
      { name: 'FlowSense FS15V', gal: 16000, url: 'https://www.turbro.com/products/flowsense-variable-speed-pool-pump' },
      { name: 'FlowSense FS25V', gal: 28000, url: 'https://www.turbro.com/products/flowsense-variable-speed-pool-pump-in-above-ground' },
      { name: 'FlowSense FS30V', gal: 40000, url: 'https://www.turbro.com/products/flowsense-variable-speed-pool-pump-in-above-ground?variant=44160479658026' }
    ];

    function setShape(shape, btn) {
      currentShape = shape;
      root.querySelectorAll('.php-tab-btn').forEach((b) => b.classList.remove('active'));
      root.querySelectorAll('.php-shape-form').forEach((form) => form.classList.remove('active'));
      btn.classList.add('active');
      root.querySelector(`[data-shape-form="${shape}"]`)?.classList.add('active');
      el('results')?.classList.remove('is-visible');
    }

    function calculate() {
      let area = 0;
      const d = parseFloat(el('shared-d')?.value) || 0;
      const inletTemp = parseFloat(el('temp-in')?.value);
      const targetTemp = parseFloat(el('temp-target')?.value);
      const targetHours = parseFloat(el('heating-days')?.value);

      if (isNaN(inletTemp) || isNaN(targetTemp) || targetTemp <= inletTemp) {
        alert(i18n.alerts?.invalid_temperatures || 'Please enter valid temperatures.');
        return;
      }

      if (currentShape === 'rect') {
        area = (parseFloat(el('rect-l')?.value) || 0) * (parseFloat(el('rect-w')?.value) || 0);
      } else if (currentShape === 'circ') {
        area = Math.PI * Math.pow(parseFloat(el('circ-r')?.value) || 0, 2);
      } else if (currentShape === 'oval') {
        area = Math.PI * (parseFloat(el('oval-a')?.value) || 0) * (parseFloat(el('oval-b')?.value) || 0);
      }

      if (area <= 0 || d <= 0) {
        alert(i18n.alerts?.invalid_dimensions || 'Please enter valid dimensions.');
        return;
      }

      const volume = area * d * 7.48;
      const tempRise = targetTemp - inletTemp;
      const totalBTULoad = volume * 8.34 * tempRise;
      const requiredBTUPerHour = (totalBTULoad / targetHours) * 2;

      let recommendedProd = products.find((p) => p.btu >= requiredBTUPerHour) || products[products.length - 1];
      let recommendedFilter = filterPumps.find((p) => volume <= p.gal) || filterPumps[filterPumps.length - 1];
      const recommendedPump = waterPumps.find((p) => volume <= p.gal) || waterPumps[waterPumps.length - 1];

      if (volume > 6000 && recommendedProd.name === 'Manatee M18') recommendedProd = products[1];
      if (volume <= 6000 && recommendedProd.name !== 'Manatee M18') recommendedFilter = filterPumps[2];

      const actualEstHours = (totalBTULoad * 2) / recommendedProd.btu;
      const actualEstDays = (actualEstHours / 24).toFixed(1);

      if (el('res-vol')) el('res-vol').textContent = `${Math.round(volume).toLocaleString()} Gal`;
      if (el('res-btu')) el('res-btu').textContent = `${Math.round(requiredBTUPerHour).toLocaleString()} BTU/hr`;
      if (el('res-rec')) el('res-rec').textContent = recommendedProd.name;
      if (el('res-time')) el('res-time').textContent = `${actualEstDays} Days`;

      if (el('product-display')) el('product-display').innerHTML = `<strong>${recommendedProd.name}</strong>`;
      if (el('product-link')) el('product-link').href = recommendedProd.url;

      const filterPumpBox = el('filter-pump-box');
      const pumpBox = el('pump-box');

      if (volume < 6000) {
        if (el('res-pump-rec')) el('res-pump-rec').textContent = recommendedFilter.name;
        if (filterPumpBox) filterPumpBox.style.display = 'flex';
        if (pumpBox) pumpBox.style.display = 'none';
        if (el('filter-pump-display')) el('filter-pump-display').innerHTML = `<strong>${recommendedFilter.name}</strong>`;
        if (el('filter-pump-link')) el('filter-pump-link').href = recommendedFilter.url;
      } else if (volume > 16000) {
        if (el('res-pump-rec')) el('res-pump-rec').textContent = recommendedPump.name;
        if (filterPumpBox) filterPumpBox.style.display = 'none';
        if (pumpBox) pumpBox.style.display = 'flex';
        if (el('pump-display')) el('pump-display').innerHTML = `<strong>${recommendedPump.name}</strong>`;
        if (el('pump-link')) el('pump-link').href = recommendedPump.url;
      } else {
        if (el('res-pump-rec')) el('res-pump-rec').innerHTML = `${recommendedFilter.name}<br>or<br>${recommendedPump.name}`;
        if (filterPumpBox) filterPumpBox.style.display = 'flex';
        if (pumpBox) pumpBox.style.display = 'flex';
        if (el('filter-pump-display')) el('filter-pump-display').innerHTML = `<strong>${recommendedFilter.name}</strong>`;
        if (el('filter-pump-link')) el('filter-pump-link').href = recommendedFilter.url;
        if (el('pump-display')) el('pump-display').innerHTML = `<strong>${recommendedPump.name}</strong>`;
        if (el('pump-link')) el('pump-link').href = recommendedPump.url;
      }

      el('results')?.classList.add('is-visible');
    }

    root.querySelectorAll('[data-php-shape]').forEach((btn) => {
      btn.addEventListener('click', () => setShape(btn.dataset.phpShape, btn));
    });

    root.querySelector('[data-php-calculate]')?.addEventListener('click', calculate);
  });
});
